import { SvgIcon } from "@mui/material";
import React from "react";

export default function EmailMessageIcon({ ...props }) {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      stroke="inherit"
      {...props}
    >
      <path
        d="M14.6666 4.6665L8.67259 8.4845C8.46918 8.60265 8.23814 8.66487 8.00292 8.66487C7.76769 8.66487 7.53666 8.60265 7.33325 8.4845L1.33325 4.6665"
        fill="none"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3333 2.6665H2.66659C1.93021 2.6665 1.33325 3.26346 1.33325 3.99984V11.9998C1.33325 12.7362 1.93021 13.3332 2.66659 13.3332H13.3333C14.0696 13.3332 14.6666 12.7362 14.6666 11.9998V3.99984C14.6666 3.26346 14.0696 2.6665 13.3333 2.6665Z"
        fill="none"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
